import { render } from "./reportheadertab.vue?vue&type=template&id=6e3b428c&scoped=true"
import script from "./reportheadertab.vue?vue&type=script&lang=js"
export * from "./reportheadertab.vue?vue&type=script&lang=js"

import "./reportheadertab.vue?vue&type=style&index=0&id=6e3b428c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e3b428c"]])

export default __exports__